import Editable from './Editable'

export default Editable
